export default __webpack_public_path__ + "static/media/bannerTwo.1e8d8637.png";